import { render } from "./terms-and-condtion.vue?vue&type=template&id=da1d6c20"
import script from "./terms-and-condtion.vue?vue&type=script&lang=js"
export * from "./terms-and-condtion.vue?vue&type=script&lang=js"

import "./terms-and-condtion.vue?vue&type=style&index=0&id=da1d6c20&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__